import type { Row } from '@tanstack/react-table';

export function getNameSorting<DataType>() {
  return (rowA: Row<DataType>, rowB: Row<DataType>, columnId: string) => {
    const valueA = rowA.getValue<string>(columnId) || '';
    const valueB = rowB.getValue<string>(columnId) || '';

    return valueA.localeCompare(valueB, 'en', {
      sensitivity: 'accent',
      usage: 'sort',
      ignorePunctuation: true,
    });
  };
}
